<template>
  <h1>Hello World</h1>
</template>

<script>
export default {
    name : "IFrame",
    created() {

        const item = localStorage.getItem('storesLogo')
        if(!item) return 
        
        localStorage.removeItem('storesLogo')
        window.top.postMessage(item, process.env.CENTRAL_ACC_URL)
    },
}
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/IFrame.vue